import React, { useState, useEffect, useRef} from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Grid2,
  Tooltip,
} from "@mui/material";
import { toast } from "sonner";
import { Iconify } from "../Minimal/src/components/iconify";
import axios from "axios";
import config from "../common/Config";
import ProductBatch from "./ProductBatch";
import '../common/commonStyles.css';

const PurchasesAddFrom = () => {
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [supplierFilteredOptions, setSupplierFilteredOptions] = useState([]);
  const [supplierValue, setSupplierValue] = useState("");
  const [supplierInputValue, setSupplierInputValue] = useState("");
  const [productBatch, setProductBatch] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [productFilteredOptions, setProductFilteredOptions] = useState([]);
  const [productValue, setProductValue] = useState(null);
  const [productInputValue, setProductInputValue] = useState("");
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem('token');
  const roleID = localStorage.getItem("roleID");
  const [newProductList, setNewProductList] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const tableRef = React.useRef(null);
  const [note, setNote] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [reference_number, setReference_number] = useState("");
  const productBatchRef = useRef(null);
  const [modalData, setModalData] = useState(null);
  const [netStdGoods, setNetStdGoods] = useState(0);
  const [netVatAmt, setNetVatAmt] = useState(0);
  const [netZeroGoods, setNetZeroGoods] = useState(0);
  const [netGrandTotal, setNetGrandTotal] = useState(0);
  const [netWeight, setNetWeight] = useState(0);
  const [grossWeight, setGrossWeight] = useState(0);
  const [highlightedProductId, setHighlightedProductId] = useState(null);
  const company_tax_type = localStorage.getItem("company_tax_type");

  const supplierHandleChange = (event, selectedOption) => {
    setSupplierValue(selectedOption);
    setSelectedSupplier(selectedOption ? selectedOption.value : "");
    setTableRows([]);
    if (selectedOption && selectedOption.value) {
      fetchProductList(selectedOption.value);
      fetchSupplierProductInfo(selectedOption.value);
    } else {
      setProductOptions([]);
      setProductFilteredOptions([]);
      setProductValue(null);
      setTableRows([]);
      setNewProductList([]);
      setNetStdGoods(0);
      setNetVatAmt(0);
      setNetZeroGoods(0);
      setNetGrandTotal(0);
    }
  };

  const supplierHandleInputChange = (event, inputValue) => {
    setSupplierInputValue(inputValue);
    const newFilteredOptions = supplierOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setSupplierFilteredOptions(newFilteredOptions);
  };

  const productHandleChange = (event, selectedOption) => {
    if (selectedOption) {
      setProductValue(selectedOption);
      fetchAddProductInfo(selectedOption.value);
    } else {
      setProductValue(null);
    }
  };

  const productHandleInputChange = (event, inputValue) => {
    setProductInputValue(inputValue);
    const newFilteredOptions = productOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setProductFilteredOptions(newFilteredOptions);
  };

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };

  const getProductBatchData = async (id, batch_id) => {
    try {
      const formData = new FormData();
      formData.set("product_id", id);
      const response = await axios.post(
        `${config.API_URL}/ws-batch-info-by-product-id`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;

      setProductBatch(data.batch);
      handleOpenPastPurchaseModal(data.batch);
    } catch (error) {
    }
  };

  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();
    }
  };

  const fetchSupplierProductInfo = async (supplierid) => {
    const formData = new FormData();
    formData.append("supplier_id", supplierid);
    formData.append("product_id", "");

    const apiUrl = `${config.API_URL}/purchases/get_order_datails`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch new product");
      }

      const data = await response.json();

      if (!data || !data.data || !Array.isArray(data.data)) {
        return;
      }

      setNewProductList(data.data);
      let stdGoods = 0;
      let totalVat = 0;
      let zeroGoods = 0;

      const averageData = data.averageData || [];
      const onOrderDataList = data.on_order_data || [];

      const newRows = data.data.map((productData) => {
        const productId = String(productData.id);

        const averageProduct = averageData.find(
          (item) => String(item.id) === productId
        );
        const salesAvgQuantity = averageProduct
          ? parseFloat(averageProduct.sales_avg_quantity || 0).toFixed(2)
          : "0.00";

        const number = parseFloat(salesAvgQuantity);
        const adjustedValue =
          number % 1 >= 0.5 ? Math.ceil(number) : Math.floor(number);

        const onOrderData = onOrderDataList.find(
          (item) => String(item.id) === productId
        );
        const onOrderQuantity = onOrderData
          ? parseInt(onOrderData.on_order_data || 0)
          : 0;
        const stockCount =
          productData.split == "0" || productData.split == "2"
            ? parseFloat(productData.quantity || 0)
            : parseFloat(productData.split_quantity || 0);

        const deficit =
          parseInt(stockCount) -
          parseInt(onOrderQuantity) -
          parseFloat(adjustedValue);

        // salesAvgQuantity is a one month estimate quantity
        const unitCost =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.cost)
            : parseFloat(productData.piece_cost);


        const vatCalc = productData.rate !== null
          ? ((unitCost * 0 * formatNumber(productData.rate)) / 100)
          : 0;
        const vat = (isNaN(vatCalc) ? 0 : vatCalc).toFixed(2);

        const net_weight =
          productData.net_weight === null ? 0 : productData.net_weight;
        const gross_weight =
          productData.gross_weight === null ? 0 : productData.gross_weight;

        const unitSellPrice =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.price || 0)
            : parseFloat(productData.split_price || 0);

        return {
          code: productData.code,
          id: productData.id,
          pack: productData.pack,
          price: productData.price,
          piece_cost: productData.piece_cost,
          split: productData.split,
          type:
            productData.split === "0" || productData.split === "2"
              ? "box"
              : "piece",
          split_quantity: productData.split_quantity,
          split_price: productData.split_price,
          name: productData.name,
          size: productData.size,
          cost: productData.cost,
          rate: productData.rate,
          net_weight: net_weight,
          gross_weight: gross_weight,
          quantity: productData.quantity,
          pdtcost: unitCost.toFixed(2),
          sellPrice: (isNaN(unitSellPrice) ? 0 : unitSellPrice).toFixed(2),
          order_qty: 0,
          subtotal: (unitCost * 0).toFixed(2),
          vat: (isNaN(parseFloat(vat)) ? 0 : parseFloat(vat)).toFixed(2),
          sales_quantity: parseFloat(productData.sales_quantity || 0) || 0,
          salesAvgQuantity: adjustedValue,
          onOrderQuantity: onOrderQuantity,
          deficit: deficit,
          category: productData.category || productData.categorie_name,
          total: (
            unitCost * 0 +
            (unitCost *
              0 *
              formatNumber(productData.rate !== null ? productData.rate : 0)) /
            100
          ).toFixed(2),
          stockCount: stockCount,
        };
      });

      setNetStdGoods(0);
      setNetVatAmt(0);
      setNetZeroGoods(0);
      setNetGrandTotal(0);

      setTableRows(newRows);
    } catch (error) {
    }
  };


  const fetchAddProductInfo = async (selectedOption) => {
    const formData = new FormData();

    if (selectedOption) {
      formData.append("product_id", selectedOption);
      const existingProduct = tableRows.find(
        (item) => item.id === selectedOption
      );
      if (existingProduct) {
        setHighlightedProductId(selectedOption);
        toast.error("This product already exists in the list. Please update the quantity.");
        setTimeout(() => {
          setHighlightedProductId(null);
        }, 5000);
        setProductValue(null);
        return;
      }
    }

    formData.append("supplier", supplierValue.value);
    const apiUrl = `${config.API_URL}/purchases/get_order_datails`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch new product");
      }

      const data = await response.json();
      const productDataList = data.data;
      setNewProductList(productDataList);

      const newRows = productDataList.map((productData) => {
        const averageProduct = data.averageData.find(
          (item) => item.id === productData.id
        );
        const salesAvgQuantity = averageProduct
          ? parseFloat(averageProduct.sales_avg_quantity).toFixed(2)
          : "0.00";
        const number = parseFloat(salesAvgQuantity);
        const adjustedValue =
          number % 1 >= 0.5 ? Math.ceil(number) : Math.floor(number);
        const onOrderData = data.on_order_data.find(
          (item) => item.id === productData.id
        );
        const onOrderQuantity = onOrderData
          ? parseInt(onOrderData.on_order_data)
          : 0; // Default to 0 if not found
        const stockCount =
          productData.split === "0" || productData.split === "2"
            ? parseInt(productData.quantity)
            : parseInt(productData.split_quantity);
        // Calculate the deficit
        const deficit =
          parseInt(stockCount) - onOrderQuantity - parseFloat(adjustedValue);

        const unitCost =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.cost)
            : parseFloat(productData.piece_cost);

        const net_weight =
          productData.net_weight === null ? 0 : productData.net_weight;
        const gross_weight =
          productData.gross_weight === null ? 0 : productData.gross_weight;

        // Calculate sell price based on type
        const unitSellPrice =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.price)
            : parseFloat(productData.split_price);

        const newRow = {
          code: productData.code,
          id: productData.id,
          pack: productData.pack,
          price: productData.price,
          piece_cost: productData.piece_cost,
          split: productData.split,
          type:
            productData.split === "0" || productData.split === "2"
              ? "box"
              : "piece",
          split_quantity: productData.split_quantity,
          split_price: productData.split_price,
          name: productData.name,
          size: productData.size,
          cost: productData.cost,
          rate: productData.rate,
          net_weight: net_weight,
          gross_weight: gross_weight,
          quantity: productData.quantity,
          pdtcost: (isNaN(unitCost) ? 0 : unitCost).toFixed(2), // formatted unit cost
          sellPrice: (isNaN(unitSellPrice) ? 0 : unitSellPrice).toFixed(2), // formatted sell price
          order_qty: 0,
          subtotal: (isNaN(unitCost) ? 0 : unitCost * 0).toFixed(2), // subtotal calculation
          vat: (() => {
            const vatCalc = (unitCost * 0 * formatNumber(productData.rate)) / 100;
            return (isNaN(vatCalc) ? 0 : vatCalc).toFixed(2);
          })(), // VAT calculation
          sales_quantity: parseInt(productData.sales_quantity),
          salesAvgQuantity: adjustedValue,
          onOrderQuantity: onOrderQuantity,
          deficit: deficit,
          category: productData.category || productData.categorie_name || "",
          total: (() => {
            const totalCalc = unitCost * 0 + (unitCost * 0 * formatNumber(productData.rate)) / 100;
            return (isNaN(totalCalc) ? 0 : totalCalc).toFixed(2);
          })(), // total including VAT
          stockCount: stockCount,
        };

        return newRow; // Return the new row object
      });

      setTableRows((prevRows) => [...newRows, ...prevRows]);
    } catch (error) {
    }
  };

  const fetchSupplierList = async () => {
    const apiSalesRouteUrl = `${config.API_URL}/purchases/getSupplier`;
    try {
      const response = await fetch(apiSalesRouteUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const formattedOptions = data.supplier.map((item) => ({
        label: item.company,
        value: item.id,
      }));
      setSupplierOptions(formattedOptions);
      setSupplierFilteredOptions(formattedOptions);
    } catch (error) {
    }
  };

  const fetchProductList = async (supplierId) => {
    const formData = new FormData();
    formData.append("supplier_id", supplierId);
    const apiSalesRouteUrl = `${config.API_URL}/purchases/getProducts`;
    try {
      const response = await fetch(apiSalesRouteUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      const formattedOptions = data.products.map((item) => ({
        label: item.name + "(" + item.code + ")" + " - " + item.size,
        value: item.id,
      }));
      setProductOptions(formattedOptions);
      setProductFilteredOptions(formattedOptions);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchSupplierList();
  }, []);

  useEffect(() => {
    let stdGoods = 0;
    let totalVat = 0;
    let zeroGoods = 0;
    let netWeightTotal = 0;
    let netGrossTotal = 0;

    const calculateTotals = () => {
      const newRows = tableRows.map((productData) => {
        const subtotal = parseFloat(productData.subtotal) || 0;
        const vat = parseFloat(productData.vat) || 0;
        const rate = parseFloat(productData.rate) || 0;

        if (rate > 0) {
          stdGoods += isNaN(subtotal) ? 0 : subtotal;
        }

        if (rate === 0.0) {
          zeroGoods += isNaN(subtotal) ? 0 : subtotal;
        }

        totalVat += isNaN(vat) ? 0 : vat;
        const netWeight = parseFloat(productData.net_weight || "0") || 0;
        const grossWeight = parseFloat(productData.gross_weight || "0") || 0;
        const orderQty = parseInt(productData.order_qty || "0") || 0;
        netWeightTotal += (isNaN(netWeight) ? 0 : netWeight) * (isNaN(orderQty) ? 0 : orderQty);
        netGrossTotal += (isNaN(grossWeight) ? 0 : grossWeight) * (isNaN(orderQty) ? 0 : orderQty);
      });

      setNetStdGoods(isNaN(stdGoods) ? 0 : stdGoods);
      setNetVatAmt(isNaN(totalVat) ? 0 : totalVat);
      setNetZeroGoods(isNaN(zeroGoods) ? 0 : zeroGoods);

      const GrandTotal = stdGoods + totalVat + zeroGoods;
      setNetGrandTotal(isNaN(GrandTotal) ? 0 : GrandTotal);
      setNetWeight(isNaN(netWeightTotal) ? 0 : netWeightTotal);
      setGrossWeight(isNaN(netGrossTotal) ? 0 : netGrossTotal);
    };

    calculateTotals();
  }, [tableRows]);

  useEffect(() => {
    if (highlightedProductId) {
      const timer = setTimeout(() => {
        const rowElement = document.querySelector(`tr[data-product-id="${highlightedProductId}"]`);
        if (rowElement) {
          rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [highlightedProductId]);

  const handleQuantityChange = (id, newQty) => {
    const row = tableRows.find((item) => item.id === id);
    const isMeatsCategory = row && (row.category === "MEATS" || row.category === "Meats" || row.category === "meats");

    if (newQty === "" || newQty === null || newQty === undefined) {
      setTableRows((prevRows) => {
        return prevRows.map((row) => {
          if (row.id === id) {
            return { ...row, order_qty: "" };
          }
          return row;
        });
      });
      return;
    }

    let isValid = false;
    if (isMeatsCategory) {
      isValid = /^\d*\.?\d*$/.test(newQty);
      if (isValid) {
        const parts = newQty.split('.');
        if (parts.length > 1 && parts[1].length > 2) {
          return;
        }
      }
    } else {
      isValid = /^[0-9]*$/.test(newQty);
    }

    if (!isValid) {
      return;
    }

    const numValue = newQty === "" || newQty === "." ? 0 : parseFloat(newQty) || 0;
    if (numValue > 9999.99) {
      toast.error("Limit: Maximum order quantity is 9999.99");
      return;
    }

    setTableRows((prevRows) => {
      return prevRows.map((row) => {
        if (row.id === id) {
          const order_qty = numValue;
          const unitCost = parseFloat(row.pdtcost) || 0;
          const rate = parseFloat(row.rate) || 0;
          const subtotalCalc = order_qty * unitCost;
          const vatCalc = (order_qty * unitCost * rate) / 100;
          const subtotal = (isNaN(subtotalCalc) ? 0 : subtotalCalc).toFixed(2);
          const vat = (isNaN(vatCalc) ? 0 : vatCalc).toFixed(2);
          const totalCalc = parseFloat(subtotal) + parseFloat(vat);
          const total = (isNaN(totalCalc) ? 0 : totalCalc).toFixed(2);
          return {
            ...row,
            order_qty: newQty,
            subtotal,
            vat,
            total,
          };
        }
        return row;
      });
    });
  };

  const handleCostChange = (id, newCost) => {
    if (newCost === "" || newCost === ".") {
      setTableRows((prevRows) => {
        return prevRows.map((row) => {
          if (row.id === id) {
            return { ...row, pdtcost: newCost };
          }
          return row;
        });
      });
      return;
    }
    
    if (!/^\d*\.?\d*$/.test(newCost)) {
      return;
    }
    
    const parts = newCost.split('.');
    if (parts.length > 1 && parts[1].length > 2) {
      return;
    }
    
    const numValue = parseFloat(newCost);
    if (isNaN(numValue)) {
      return;
    }
    
    if (numValue > 9999.99) {
      toast.error("Limit: Maximum cost price is 9999.99");
      return;
    }
    
    setTableRows((prevRows) => {
      return prevRows.map((row) => {
        if (row.id === id) {
          const order_qty = parseFloat(row.order_qty) || 0;
          const rate = parseFloat(row.rate) || 0;
          const subtotalCalc = order_qty * numValue;
          const vatCalc = (order_qty * numValue * rate) / 100;
          const subtotal = (isNaN(subtotalCalc) ? 0 : subtotalCalc).toFixed(2);
          const vat = (isNaN(vatCalc) ? 0 : vatCalc).toFixed(2);
          const totalCalc = parseFloat(subtotal) + parseFloat(vat);
          const total = (isNaN(totalCalc) ? 0 : totalCalc).toFixed(2);
          return {
            ...row,
            pdtcost: newCost,
            subtotal,
            vat,
            total,
          };
        }
        return row;
      });
    });
  };

  const handleSellPriceChange = (id, newSellPrice) => {
    if (newSellPrice === "" || newSellPrice === ".") {
      setTableRows((prevRows) => {
        return prevRows.map((row) => {
          if (row.id === id) {
            return { ...row, sellPrice: newSellPrice };
          }
          return row;
        });
      });
      return;
    }
    
    if (!/^\d*\.?\d*$/.test(newSellPrice)) {
      return;
    }
    
    const parts = newSellPrice.split('.');
    if (parts.length > 1 && parts[1].length > 2) {
      return;
    }
    
    const numValue = parseFloat(newSellPrice);
    if (isNaN(numValue)) {
      return;
    }
    
    setTableRows((prevRows) => {
      return prevRows.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            sellPrice: numValue,
          };
        }
        return row;
      });
    });
  };

  const handleOptionChange = (id, pdtType) => {
    setTableRows((prevRows) => {
      return prevRows.map((row) => {
        if (row.id === id) {
          const pdtcost = parseFloat(pdtType === "Box" ? row.cost : row.piece_cost) || 0;
          const sellPrice = parseFloat(pdtType === "Box" ? row.price : row.split_price) || 0;
          const order_qty = parseFloat(row.order_qty) || 0;
          const rate = parseFloat(row.rate) || 0;
          const subtotalCalc = order_qty * pdtcost;
          const vatCalc = (order_qty * pdtcost * rate) / 100;
          const subtotal = (isNaN(subtotalCalc) ? 0 : subtotalCalc).toFixed(2);
          const vat = (isNaN(vatCalc) ? 0 : vatCalc).toFixed(2);
          const totalCalc = parseFloat(subtotal) + parseFloat(vat);
          const total = (isNaN(totalCalc) ? 0 : totalCalc).toFixed(2);
          const type = pdtType === "Piece" ? "box" : "piece";
          const stockCount =
            pdtType == "Box"
              ? parseInt(row.quantity || 0)
              : parseInt(row.split_quantity || 0);

          return {
            ...row,
            type,
            pdtcost,
            //  sellPrice: parseFloat(sellPrice).toFixed(2),
            subtotal,
            vat,
            total,
            stockCount,
          };
        }
        return row;
      });
    });
  };
  const handleCancel = (id) => {
    setTableRows((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  const handleChange = (event) => {
    setNote(event.target.value);
  };

  const submitFormData = async () => {
    if (!supplierValue || !supplierValue.value) {
      toast.error("Please select a supplier.");
      return;
    }

    const orderedRows = tableRows.filter((row) => parseFloat(row.order_qty) > 0);

    if (orderedRows.length === 0) {
      toast.error("Please add at least one product with quantity greater than 0.");
      return;
    }

    // Build FormData manually to only include ordered rows (qty > 0)
    const formData = new FormData();
    formData.append("supplier", supplierValue.value);

    // Only append form fields for rows with quantity > 0
    orderedRows.forEach((row) => {
      formData.append("product_id[]", row.id);
      formData.append("code[]", row.code);
      formData.append("name[]", row.name);
      formData.append("order_qty[]", row.order_qty);
      formData.append("subtotal[]", row.subtotal);
      formData.append("vat[]", row.vat);
      formData.append("total[]", row.total);
      formData.append("type[]", row.type);
      formData.append("cost[]", row.pdtcost);
      if (row.sellPrice) {
        formData.append("sell_price[]", row.sellPrice);
      }
    });

    formData.append("note", note);
    formData.append("warehouse", "1");
    formData.append("reference_number", reference_number);
    const apiSalesRapUrl = `${config.API_URL}/purchases/purchasesAdd`;
    try {
      const response = await fetch(apiSalesRapUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success == true) {
        toast.success("Purchase Added successfully.");
        setTimeout(() => {
          window.location.href = `${config.BASE_URL}/purchases/purchases_order/`;
        }, 1500);
      } else {
        toast.error("Purchase Failed");
      }
    } catch (error) {
    }

    setTableRows([]);
    setSupplierValue("");
    setNote("");
  };

  return (
    <>
      <ProductBatch
        onViewPastPurchase={(showModal) => {
          productBatchRef.current = showModal;
        }}
        getProductBatchData={getProductBatchData}
        modalData={modalData}
      />

      <Box sx={{ width: "100%", p: 1.5, backgroundColor: "#f5f7fa" }} >
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            border: "1px solid rgba(145, 158, 171, 0.16)",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Box sx={{ p: 2 }}>
            <Grid2 container spacing={1} sx={{ mb:1}}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Autocomplete
                  options={supplierFilteredOptions}
                  value={supplierValue}
                  onChange={supplierHandleChange}
                  onInputChange={supplierHandleInputChange}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Supplier"
                      size="small"
                      className="input-border"
               
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Autocomplete
                  options={productFilteredOptions}
                  value={productValue}
                  onChange={productHandleChange}
                  onInputChange={productHandleInputChange}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Product"
                      size="small"
                      className="input-border"
               
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  size="small"
                  className="input-border"
                  placeholder="Reference No"
                  value={reference_number}
                  onChange={(e) => setReference_number(e.target.value)}
          
                />
              </Grid2>
            </Grid2>
            <Typography sx={{ mb: 0.5, fontWeight: 500, color: "#212b36", fontSize: "1rem" }}>
              Order Items
            </Typography>
            <TableContainer>
              <Table size="medium" className="table-cell-border" sx={{ tableLayout: "fixed" }}>
                <TableHead>
                  <TableRow className="table-cell-header">
                    <TableCell
                      sx={{

                        width: "280px",
                        minWidth: "280px",
                      }}
                    >
                      Code-Name-Size
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "80px",
                        minWidth: "80px",
                        textAlign: "center",
                      }}
                    >
                      PK
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "120px",
                        minWidth: "100px",
                      }}
                    >
                      Current Stock
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        On Order
                        <Tooltip title="PO Qty with Draft or Partial status" arrow>
                          <Iconify icon="eva:info-outline" width={16} sx={{ color: "#637381" }} />
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        Estimated
                        <Tooltip title="Avg 2 month sell" arrow>
                          <Iconify icon="eva:info-outline" width={16} sx={{ color: "#637381" }} />
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        Deficit
                        <Tooltip title="Current stock - On order Stock - Estimate" arrow>
                          <Iconify icon="eva:info-outline" width={16} sx={{ color: "#637381" }} />
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                      }}
                    >
                      Order QTY
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                        textAlign: "center",
                      }}
                    >
                      Type
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "115px",
                        minWidth: "115px",
                      }}
                    >
                      Cost Price
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                        textAlign: "right",
                      }}
                    >
                      Sells Price
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                        textAlign: "right",
                      }}
                    >
                      {company_tax_type}
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                        textAlign: "right",
                      }}
                    >
                      Sub Total
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "100px",
                        minWidth: "100px",
                        textAlign: "right",
                      }}
                    >
                      Net P
                    </TableCell>
                    <TableCell
                      sx={{

                        width: "80px",
                        minWidth: "80px",
                        textAlign: "center",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={14} sx={{ textAlign: "center", py: 3 }}>
                        No product added
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableRows.map((row) => {
                      const hasQuantity = parseFloat(row.order_qty) > 0;
                      const isHighlighted = highlightedProductId === row.id;
                      return (
                        <TableRow
                          key={row.id}
                          data-product-id={row.id}
                          sx={{
                            backgroundColor: isHighlighted ? "#cfe2ff" : "transparent",
                            transition: "background-color 0.3s ease",

                            "&:hover": {
                              backgroundColor: isHighlighted ? "#cfe2ff" : "rgba(145, 158, 171, 0.08)",
                            },
                            "& .MuiTableCell-root": {
                              fontSize: "0.75rem",
                              color: "#212b36",
                              py: 1,

                            },
                          }}
                        >
                          <TableCell
                          >
                            {row.code} - {row.name} - {row.size}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {row.pack}
                          </TableCell>
                          <TableCell

                          >
                            {row.stockCount}
                          </TableCell>
                          <TableCell

                          >
                            {row.onOrderQuantity}
                          </TableCell>
                          <TableCell

                          >
                            {row.salesAvgQuantity}
                          </TableCell>
                          <TableCell

                          >
                            {row.deficit}
                          </TableCell>
                          <TableCell

                          >
                            <TextField
                            className="input-border"
                              onFocus={(e) => e.target.select()}
                              type="text"
                              value={row.order_qty}
                              onChange={(e) => handleQuantityChange(row.id, e.target.value)}
                              onKeyDown={(e) => {
                                const isMeatsCategory = row && (row.category === "MEATS" || row.category === "Meats" || row.category === "meats");
                                if (!isMeatsCategory && ['e', 'E', '+', '-', '.'].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              size="small"
                              sx={{
                                "& .MuiOutlinedInput-root": {

                                  backgroundColor: "#f5f7fa",
                                  fontSize: "0.875rem",
                                  height: "30px",
                                  "&:hover": {
                                    backgroundColor: "#fff",
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "#fff",
                                  },
                                },
                              }}
                              inputProps={{
                                style: { textAlign: "center", padding: "8px" },
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {row.split == 2 ? (
                              <FormControl size="small" fullWidth>
                                <Select
                                  value={row.type === "box" ? "Box" : "Piece"}
                                  onChange={(e) => handleOptionChange(row.id, e.target.value)}
                                  sx={{
                                    "& .MuiSelect-select": {
                                      fontSize: "0.75rem",
                                    },
                                    backgroundColor: "#f5f7fa",
                                    height: "28px",
                                    "&:hover": {
                                      backgroundColor: "#fff",
                                    },
                                    "&.Mui-focused": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                >
                                  <MenuItem value="Box">Box</MenuItem>
                                  <MenuItem value="Piece">Piece</MenuItem>
                                </Select>
                              </FormControl>
                            ) : (
                              row.split == 0 ? "Box" : "Piece"
                            )}
                          </TableCell>
                          <TableCell
                          >
                            <TextField
                              className="input-border"
                              type="text"
                              value={row.pdtcost}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                  handleCostChange(row.id, value);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (['e', 'E', '+', '-'].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              size="small"
                              disabled={roleID === "20"}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#f5f7fa",
                                  height: "28px",

                                  "&:hover": {
                                    backgroundColor: "#fff",
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "#fff",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "0.75rem",
                              color: "#212b36",
                              py: 1,
                              textAlign: "right",
                              fontWeight: 500,
                              borderBottomColor: "rgba(145, 158, 171, 0.16)",
                            }}
                          >
                            {parseFloat(row.sellPrice || row.price || 0).toFixed(2)}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "right",
                            }}
                          >
                            {row.vat}
                          </TableCell>
                          <TableCell
                            sx={{ textAlign: "right", }}
                          >
                            {row.subtotal}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "right",
                            }}
                          >
                            {row.total}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <IconButton
                              onClick={() => handleCancel(row.id)}
                              size="small"
                              sx={{
                                color: "#d32f2f",
                                "&:hover": {
                                  backgroundColor: "rgba(211, 47, 47, 0.08)",
                                },
                              }}
                            >
                              <Iconify icon="eva:trash-2-outline" width={20} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Grid2 container spacing={2} sx={{
              my: 2, p: 1, borderRadius: 1,
              border: "1px solid rgba(44, 44, 44, 0.68)",
              backgroundColor: "#f5f7fa",
            }}>
              <Grid2 size={{ xs: 6, md: 3 }}>
                <Box
                  sx={{

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2" sx={{mb: 0.5 }}>
                    VAT Goods :
                  </Typography>
                  <Typography sx={{ color: "#212b36", fontWeight: 500, fontSize: "1rem" }}>
                    {netStdGoods.toFixed(2)}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6, md: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    {company_tax_type} Amount :
                  </Typography>
                  <Typography sx={{ color: "#212b36", fontWeight: 500, fontSize: "1rem" }}>
                    {netVatAmt.toFixed(2)}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6, md: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    Zero VAT Goods :
                  </Typography>
                  <Typography sx={{ color: "#212b36", fontWeight: 500, fontSize: "1rem" }}>
                    {netZeroGoods.toFixed(2)}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6, md: 3 }}>
                <Box
                  sx={{

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    Gross Total :
                  </Typography>
                  <Typography sx={{ color: "#212b36", fontWeight: 500, fontSize: "1rem" }}>
                    {netGrandTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Grid2>
            </Grid2>

            <Box sx={{ my:2 }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: "#212b36" }}>
                Note
              </Typography>
              <TextField
                multiline
                className="form-input-border"
                rows={2}
                fullWidth
                value={note}
                onChange={handleChange}
                // sx={{
                //   "& .MuiOutlinedInput-root": {
                //     backgroundColor: "#f5f7fa",
                //     fontSize: "0.875rem",
                //     "&:hover": {
                //       backgroundColor: "#fff",
                //     },
                //     "&.Mui-focused": {
                //       backgroundColor: "#fff",
                //     },
                //   },
                // }}
              />
            </Box>

            <Box sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                onClick={submitFormData}
                className="button-variant-contained"
              >
                Add Order
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default PurchasesAddFrom;
